module.exports = __webpack_public_path__ + "img/drop-down.60b00a32.svg";